import { PartnerCertificate } from './partner-certificate';

export class CertificateHandlerParseResult {
    Status: string;
    StatusText?: any;
    PartnerCertificates: PartnerCertificate[];
    Token: string;

    // Enum replacements...
    static ParseResultSuccess = 'Success';
    static ParseResultWrongPassword = 'WrongPassword';
    static ParseResultError = 'Error';
}